// libraries
import { AxiosResponse } from 'axios';

// api
import apiRequest from 'api/restapi';

const getMainPageConnection = (): Promise<AxiosResponse<any>> =>
  apiRequest.get('/main-page-connection?isDisplayed=true');

const getInstagramMedia = (): Promise<AxiosResponse<any>> =>
  apiRequest.get('https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,permalink&access_token=IGQVJXdWxXYVJQSlM3b3ZAqYWlpcDNESVc1U0l5R3FvZAVlOeXl5V3h2Sk9fVHdMLURMUC1LeE4yM0tfd0M4bC1ySC1vUEpMVTk3bzUweHlIWi1LV1FxSWlFWVZAlYlM1Um1GNHZARR2d2ME5lRVNhcWNsegZDZD');

export default { getMainPageConnection, getInstagramMedia };
